// @ngInject
Models.BlockComponentsCollection = function BlockComponentsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'BlockComponentsCollection';
                this._collection.__childsType = 'BlockComponentModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};